import { parseOptionalNonNegativeNumber } from '../../parse-optional-non-negative-number.js';
import { toNewContactsInput } from '../contact/to-new-contacts-input.js';
import { toCreateCustomerAddressPairInput } from '../customer-address/to-create-customer-address-pair-input.js';
export function toCreateCustomerInput(values, brandIds, { license, address, contacts }) {
    const creditLimit = parseOptionalNonNegativeNumber(values.creditLimit, 'Credit limit');
    return {
        name: values.name.trim(),
        url: values.url.trim() || undefined,
        note: values.note.trim() || undefined,
        email: values.email?.trim() || undefined,
        phone: values.phone.trim() || undefined,
        deliveryPreferences: values.deliveryPreferences.trim() || undefined,
        currencyId: values.currencyId.trim() || undefined,
        paymentTermsId: values.paymentTermsId.trim() || undefined,
        shipTermsId: values.shipTermsId.trim() || undefined,
        creditLimit: typeof creditLimit === 'number' ? creditLimit : undefined,
        taxExempt: values.taxExempt,
        taxExemptNumber: values.taxExemptNumber.trim() || undefined,
        taxRateId: values.taxRateId.trim() || undefined,
        brandIds,
        license: license
            ? {
                licenseNumber: license.licenseNumber,
                licenseType: license.licenseType ?? undefined,
                stateId: license.stateId,
                issuedAt: license.issuedAt ?? undefined,
                expiresAt: license.expiresAt ?? undefined,
            }
            : undefined,
        address: address ? toCreateCustomerAddressPairInput(address) : undefined,
        contacts: toNewContactsInput(contacts),
    };
}
//# sourceMappingURL=create-mapper.js.map